import { z } from 'zod'

// Identity（Auth0 アカウント）のロール。テナント内の UserRole とは別物
export const identityRoleSchema = z.enum(['admin', 'member'])
export type IdentityRole = z.infer<typeof identityRoleSchema>

export const identityRoleLabels = {
  admin: 'admin',
  member: '一般ユーザー',
}

export const identityRoleOptions = Object.entries(identityRoleLabels).map(([key, label]) => ({
  value: key,
  label,
}))
